(function () {
  "use strict";

  const DEFAULT_SIZE = "US0";
  const UNITS = { INCH: "inch", CM: "cm" };

  let selectedSize = DEFAULT_SIZE;
  let currentUnit = UNITS.INCH;

  const elements = {
    sizeOpts: document.getElementById("sizeOpts"),
    selectedSizeDisplay: document.getElementById("selectedSize"),
    unitSwitch: document.getElementById("unitSwitch"),
    unitSubmit: document.getElementById("unitSubmit"),
    inUnit: document.getElementById("inUnit"),
    cmUnit: document.getElementById("cmUnit"),
    sizeChartBody: document.querySelector("#sizeChart tbody"),
    sizeData: document.getElementById("sizeData"),
    customerData: document.getElementById("customerData"),
    customSizeUnits: document.querySelectorAll("#customerData .unit"),
    customSizeInputs: document.querySelectorAll("#customerData [data-custom-data]"),
  };

  if (!elements.sizeOpts) return; // Guard clause

  const sizeRows = Array.from(elements.sizeChartBody.querySelectorAll("tr"));
  const sizesArray = sizeRows.map((row) => row.dataset.size);

  function updateUI() {
    const isCustomSize = selectedSize === "Custom Size";

    // Update size options
    elements.sizeOpts.querySelectorAll(".size-button").forEach((label) =>
      label.classList.toggle("selected", label.dataset.size === selectedSize)
    );

    // Update size chart
    elements.sizeData.classList.toggle("hidden", isCustomSize);
    elements.customerData.classList.toggle("hidden", !isCustomSize);

    if (!isCustomSize) {
      const visibleRows = getVisibleRows();
      sizeRows.forEach((row) => {
        const size = row.dataset.size;
        const isVisible = visibleRows.includes(size);
        row.style.display = isVisible ? "table-row" : "none";
        row.classList.toggle("selected", size === selectedSize);
        if (isVisible) {
          row.querySelectorAll("td:not(:first-child)").forEach((cell) => {
            cell.textContent = `${cell.dataset[currentUnit]} ${currentUnit}`;
          });
        }
      });
    }

    // Update custom size inputs
    elements.customSizeInputs.forEach((element) => {
      const customData = element.getAttribute('data-custom-data');
      element.name = isCustomSize ? customData : customData.replace('properties', 'disabled_properties');
    });

    // Update units
    elements.customSizeUnits.forEach((span) => (span.textContent = currentUnit));
    if (elements.unitSubmit) {
      elements.unitSubmit.value = currentUnit === UNITS.INCH ? "Inch" : "CM";
    }
  }

  function getVisibleRows() {
    const selectedIndex = sizesArray.indexOf(selectedSize);
    if (selectedIndex <= 0) return sizesArray.slice(0, 3);
    if (selectedIndex === sizesArray.length - 1) return sizesArray.slice(-3);
    return sizesArray.slice(selectedIndex - 1, selectedIndex + 2);
  }

  function toggleUnit() {
    currentUnit = elements.unitSwitch.checked ? UNITS.CM : UNITS.INCH;
    const isInch = currentUnit === UNITS.INCH;
    if (elements.inUnit) {
      elements.inUnit.style.fontWeight = isInch ? "bold" : "normal";
      elements.inUnit.style.color = isInch ? "#bf0008" : "#333";
    }
    if (elements.cmUnit) {
      elements.cmUnit.style.fontWeight = isInch ? "normal" : "bold";
      elements.cmUnit.style.color = isInch ? "#333" : "#bf0008";
    }
    updateUI();
  }

  function init() {
    document.addEventListener("change", (event) => {
      const target = event.target;
      if (target.id === "unitSwitch") {
        toggleUnit();
      } else if (target.name === "properties[Size]") {
        selectedSize = target.value;
        if (elements.selectedSizeDisplay) {
          elements.selectedSizeDisplay.textContent = `- ${selectedSize}`;
        }
        updateUI();
      }
    });

    // 初始化单位和自定义尺寸输入字段
    elements.customSizeUnits.forEach((span) => (span.textContent = currentUnit));
    if (elements.unitSubmit) {
      elements.unitSubmit.value = "Inch";
    }
    elements.customSizeInputs.forEach((element) => {
      const customData = element.getAttribute('data-custom-data');
      element.name = customData.replace('properties', 'disabled_properties');
    });
  }

  init();
})();
